module.exports = __webpack_public_path__ + "static/media/add-circle-filled.5fd71cba.svg";